interface ResolveMessagingPromptAvailabilityInput {
  allowGeneralPrompt: boolean;
  browserPromptDismissed: boolean;
  browserPromptResolved: boolean;
  contextualKind: "install_return" | "price_alert" | null;
  dismissed: boolean;
  emailAvailable: boolean;
  isResolved: boolean;
  telegramAuthAvailable: boolean;
  telegramConnected?: boolean;
  telegramLoading: boolean;
  webPushAvailable?: boolean;
  webPushLoading: boolean;
  whatsappAvailable?: boolean;
  whatsappLoading: boolean;
}

function resolveContextualPrompt(input: ResolveMessagingPromptAvailabilityInput) {
  const contextualPending = !input.browserPromptResolved || input.webPushLoading;
  if (contextualPending) return null;
  if (input.contextualKind === "price_alert" && input.browserPromptDismissed) return null;

  return {
    contextualKind: input.contextualKind,
    emailAvailable: false,
    telegramAvailable: false,
    whatsappAvailable: false,
  };
}

function resolveGeneralPrompt(input: ResolveMessagingPromptAvailabilityInput) {
  const generalPromptPending = [
    !input.isResolved,
    input.webPushLoading,
    input.whatsappLoading,
    input.telegramLoading,
  ].some(Boolean);
  if (generalPromptPending || input.dismissed || !input.allowGeneralPrompt) return null;

  const telegramAvailable = [input.telegramAuthAvailable, !input.telegramConnected].every(Boolean);
  const whatsappAvailable = input.whatsappAvailable === true;
  const hasAvailableChannel = [
    input.webPushAvailable === true,
    telegramAvailable,
    whatsappAvailable,
    input.emailAvailable,
  ].some(Boolean);
  if (!hasAvailableChannel) return null;

  return {
    contextualKind: null,
    emailAvailable: input.emailAvailable,
    telegramAvailable,
    whatsappAvailable,
  };
}

/** Resolves a browser-first contextual prompt or the general channel chooser. */
export function resolveMessagingPromptAvailability(input: ResolveMessagingPromptAvailabilityInput) {
  return input.contextualKind ? resolveContextualPrompt(input) : resolveGeneralPrompt(input);
}
